<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <!-- Tables controls -->
        <b-container fluid>
            <b-row class="mb-2">
                <b-col>
                    <b-form inline class="float-right">
                        <b-form-input size="sm" v-model="filterRoles" placeholder="Search Roles"
                                      class="mb-2 mr-sm-2 mb-sm-0"/>
                        <b-button v-b-modal.addModalRole variant="primary" class="btn-sm">Add Role
                            <i class="mdi mdi-add usersmanagement__add-icon"></i>
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
        <b-table responsive striped hover small :items="rolesArray" :fields="roleFields" :filter="filterRoles">
            <template v-slot:cell(Actions)="row" style="width: 100px;">
                <b-button variant="link" v-b-modal.editModalRole @click.stop="setRoleToEdit(row.item.id)"><i
                        class="fal fa-edit"></i></b-button>
                <b-button variant="link" v-b-modal.deleteModalRole
                          @click.stop="setRoleToDelete(row.item.name, row.item.id)"><i class="fal fa-trash-alt"></i>
                </b-button>
            </template>
        </b-table>
        <!-- Edit modal Role  -->
        <edit-modal-role :id="'editModalRole'" :title="editModalRoleTitle" @ok="updateRole"
                         @cancel="cancelEditRole" :roleToEdit="roleToEdit"/>
        <!-- Add modal Role  -->
        <edit-modal-role :id="'addModalRole'" :title="addModalRoleTitle" @ok="addRole"
                         @cancel="cancelEditRole" :roleToEdit="roleToEdit"/>
        <!-- Delete Confirmation modal for Role -->
        <delete-modal :id="'deleteModalRole'" @ok="deleteRole" @cancel="cancelDeleteRole"
                      :deleteModalText="deleteModalRoleText"/>
    </div>
</template>

<script>

    import {mapGetters, mapActions} from 'vuex'
    import DeleteModal from "../components/DeleteModal";
    import EditModalRole from "../components/EditModalRole";

    export default {
        name: 'rolesTable',
        components: {
            'delete-modal': DeleteModal,
            'edit-modal-role': EditModalRole
        },
        data: function () {
            return {
                roleToDelete: null,
                roleToEdit: {
                    name: '',
                    permissions: '',
                    id: ''
                },
                addModalRoleTitle: 'Add new group',
                filterRoles: '',
                busy: false
            }
        },
        mounted() {
            // Set the initial number of items
            this.busy = true;
            Promise.all([this.fetchResources(), this.fetchRoles()]).finally(() => {
                this.busy = false;
            });
        },
        computed: {
            ...mapGetters('rolesManagement', ['rolesArray', 'roleFields', 'roleById']),
            deleteModalRoleText() {
                if (this.roleToDelete) {
                    return 'Are you sure you want to delete the group ' + this.roleToDelete.name + ' ?'
                }
                return ''
            },
            editModalRoleTitle() {
                if (this.roleToEdit) {
                    return 'Edit group: ' + this.roleToEdit.name
                }
                return ''

            }
        },
        methods: {
            ...mapActions('rolesManagement', ['deleteRoleById', 'updateRoleById', 'addRoleViaAdmin']),
            ...mapActions('resourcesManagement', ['fetchResources']),
            ...mapActions('rolesManagement', ['fetchRoles']),
            deleteRole() {
                if (this.roleToDelete) {
                    this.deleteRoleById({role: this.roleToDelete});
                    this.roleToDelete = null
                }
            },
            cancelDeleteRole() {
                this.roleToDelete = null
            },
            setRoleToDelete(name, id) { // tODO id
                this.roleToDelete = {
                    id,
                    name
                }
            },
            updateRole() {
                this.updateRoleById({role: this.roleToEdit});
                this.resetRoleToEdit()
            },
            addRole() {
                delete this.roleToEdit.id;
                this.addRoleViaAdmin({role: this.roleToEdit});
                this.resetRoleToEdit()
            },
            cancelEditRole() {
                this.resetRoleToEdit()
            },
            setRoleToEdit(id) {
                this.roleToEdit = this.roleById(id)
            },
            resetRoleToEdit() {
                this.roleToEdit = {
                    name: '',
                    id: '',
                    permissions: ''
                }
            },
        }
    }
</script>
